import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { initializeIcons } from '@fluentui/react';
import { Link } from 'react-router-dom';
import Router from './Router';
import Logo from './../src/assets/images/logo.png';
import Userpic from './../src/assets/images/userpic.png';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import { SessionTimer } from './component/common/Header';
import { getUserDetail } from './utils';
import CONSTANT from "./constant";

initializeIcons()
class AppConfiguration extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            ud: getUserDetail()
        }
    }
    public render() {
        const { ud } = this.state
        let location = window.location.href != ("http://localhost:3000/" || "https://epieoffice.in//" || "https://demo-epil.mounttalent.com/")
        return (
            <React.Fragment>
                <div className='position-relative'>
                    <BrowserRouter>
                        <ToastContainer />
                        <Router />
                    </BrowserRouter>
                </div>
            </React.Fragment>
        );
    }
}
export default AppConfiguration;